import { get, writable } from "svelte/store";
export class MaxSpeedToolManager {
    constructor(parent) {
        this.visible = writable(false);
        this.parent = parent;
        this.visible.subscribe(v => this.showHide(v));
    }
    getVisibleStore() {
        return this.visible;
    }
    addToMap(map) {
        this.map = map;
        this.addLayers();
        this.showHide(get(this.visible));
    }
    addLayers() {
        if (this.map.hasLayer("maxspeed-legal"))
            return;
        const no_access = ["literal", ["no", "private"]];
        /**
         * A mapbox-expression which calculates the max speed for motorized vehicles, based on their properties
         */
        const maxspeed_expression = [
            "case",
            // First, we check if motor_vehicles are allowed. If not, we give '0' and hide the maxspeed layer
            ["any",
                ["in", ["get", "motor_vehicle"], no_access],
                ["in", ["get", "motorcar"], no_access],
                ["in", ["get", "anyways:motor_vehicle"], no_access],
                ["in", ["get", "anyways:motorcar"], no_access],
                ["==", ["get", "construction"], ["literal", "yes"]],
                ["==", ["get", "anyways:construction"], ["literal", "yes"]],
                [
                    "in",
                    ["get", "highway"],
                    [
                        "literal",
                        [
                            "cycleway",
                            "pedestrian",
                            "path",
                            "footway",
                            "crossing",
                            "construction"
                        ],
                    ],
                ]],
            "0",
            // Second: if an explicit maxspeed is given, we give this
            ["has", "maxspeed"],
            ["get", "maxspeed"],
            // Then, we apply various defaults and calculated implied values
            [
                "in",
                ["get", "highway"],
                ["literal", ["living_street"]],
            ],
            "20",
            ["any",
                ["==", ["get", "cyclestreet"], ["literal", "yes"]],
                [
                    "in",
                    ["get", "highway"],
                    ["literal", ["service", "services"]],
                ]],
            "30",
            [
                "in",
                ["get", "highway"],
                [
                    "literal",
                    [
                        "track",
                        "unclassified",
                        "tertiary",
                        "tertiary_link",
                        "road",
                        "residential",
                    ],
                ],
            ],
            "50",
            [
                "in",
                ["get", "highway"],
                [
                    "literal",
                    ["secondary", "secondary_link"],
                ],
            ],
            "70",
            [
                "in",
                ["get", "highway"],
                [
                    "literal",
                    [
                        "trunk",
                        "trunk_link",
                        "primary",
                        "primary_link",
                    ],
                ],
            ],
            "90",
            [
                "in",
                ["get", "highway"],
                ["literal", ["motorway", "motorway_link"]],
            ],
            "120",
            "0",
        ];
        // add maxspeed layer.
        this.map.addLayer({
            id: "maxspeed-legal",
            type: "line",
            source: this.parent.getCustomSourceId(),
            "source-layer": "transportation",
            paint: {
                "line-width": 6,
                "line-color": [
                    "let",
                    "maxspeed",
                    ["to-number", maxspeed_expression],
                    [
                        "case",
                        ["==", ["var", "maxspeed"], 0], "#0FFFBB",
                        ["<=", ["var", "maxspeed"], 20], "#A3FF3F",
                        ["<=", ["var", "maxspeed"], 30], "#F3FF0F",
                        ["<=", ["var", "maxspeed"], 50], "#ff9500",
                        ["<=", ["var", "maxspeed"], 70], "#ff6d00",
                        ["<=", ["var", "maxspeed"], 90], "#B70000",
                        ["<=", ["var", "maxspeed"], 120], "#B70000",
                        [">", ["var", "maxspeed"], 120], "#ff0000",
                        "#0FFFBB"
                    ],
                ],
            },
            layout: {
                visibility: "none",
            },
            filter: [
                "let",
                "maxspeed",
                maxspeed_expression,
                ["!=", ["var", "maxspeed"], "0"],
            ],
        }, "symbol");
        this.map.addLayer({
            id: "maxspeed-legal-numbers",
            type: "symbol",
            minzoom: 14.5,
            source: this.parent.getCustomSourceId(),
            "source-layer": "transportation",
            layout: {
                "symbol-placement": "line",
                "symbol-spacing": 100,
                "text-field": [
                    "format",
                    [
                        "let",
                        "maxspeed",
                        maxspeed_expression,
                        ["to-string", ["var", "maxspeed"]],
                    ],
                ],
                visibility: "none",
            },
            paint: {
                "text-color": "#000000",
                "text-halo-color": "#ffffff",
                "text-halo-width": 2,
            },
            filter: [
                "let",
                "maxspeed",
                maxspeed_expression,
                ["all", ["!=", ["var", "maxspeed"], "0"]],
            ],
        }, "label");
    }
    showHide(visible) {
        if (typeof this.map === "undefined")
            return;
        if (visible) {
            this.map.showLayer("maxspeed-legal");
            this.map.showLayer("maxspeed-legal-numbers");
        }
        else {
            this.map.hideLayer("maxspeed-legal");
            this.map.hideLayer("maxspeed-legal-numbers");
        }
    }
}
